<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <ul class="heading-ul mb-3">
          <li>
            <router-link to="/setup/usage-rating/template" class="">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            </router-link>
          </li>
          <li>
            <h3>
              <td>{{ viewBroadcaster.templateDatas[0].templateName }}</td>
            </h3>
          </li>
        </ul>
      </div>
      <div class="vx-col md:w-full lg:w-full sm:w-full w-full mb-base">
        <vx-card>
          <div class="vx-row">
            <div class="vx-col w-full md:w-full lg:w-full">
              <ul class="horizontal-sm-btn flex mb-2 float-right">
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <vs-button
                      color="primary"
                      icon-pack="feather"
                      icon="icon-edit-2"
                      class="truncate"
                      @click="editData(id)"
                      size="small"
                      >{{ $t("setup.label.Edit") }}</vs-button
                    >
                    <vs-button
                      color="danger"
                      icon-pack="feather"
                      icon="icon-x"
                      class="truncate"
                      size="small"
                      @click="deleteTemplateDefinitionPopup = true"
                      >{{ $t("setup.label.Delete") }}</vs-button
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="vx-row">
            <div class="w-full">
              <div class="block overflow-x-auto">
                <table class="table w-full table-bordered table-striped">
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.TemplateName") }}</b>
                    </td>
                    <td>{{ viewBroadcaster.templateDatas[0].templateName }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.Delimiter") }}</b>
                    </td>
                    <td>{{ viewBroadcaster.templateDatas[0].delimiter }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.NumberOfFields") }}</b>
                    </td>
                    <td>
                      {{ viewBroadcaster.templateDatas[0].numberOfFields }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.HeaderRecorderType") }}</b>
                    </td>
                    <td>
                      {{ viewBroadcaster.templateDatas[0].headerecordtype }}
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <b>{{ $t("setup.label.EventRecordType") }} </b>
                    </td>
                    <td>
                      {{ viewBroadcaster.templateDatas[0].eventrecordtype }}
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <b>{{ $t("setup.label.ServiceCode") }} </b>
                    </td>
                    <td>
                      {{ viewBroadcaster.templateDatas[0].serviceCode }}
                    </td>
                  </tr>
                  <tr>
                    <td class="border-none">
                      <b>{{ $t("setup.label.ProductCode") }} </b>
                    </td>
                    <td class="border-none">
                      {{ viewBroadcaster.templateDatas[0].productCode }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <h3>{{ $t("setup.label.ExistsTemplateDefinition") }}</h3>
          <div class="vx-row">
            <div class="w-full">
              <div class="block overflow-x-auto">
                <table class="table w-full table-bordered table-striped">
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.FieldName") }}</b>
                    </td>
                    <td>
                      <b>{{ $t("setup.label.FieldType") }}</b>
                    </td>
                    <td>
                      <b>{{ $t("setup.label.Length") }}</b>
                    </td>
                    <td>
                      <b>{{ $t("setup.label.IdentifierType") }}</b>
                    </td>
                  </tr>

                  <tr
                    v-for="(
                      Broadcaster, index
                    ) in viewBroadcaster.templateDatas"
                    :key="index"
                  >
                    <td>{{ Broadcaster.fieldName }}</td>
                    <td>{{ Broadcaster.fieldType }}</td>
                    <td>{{ Broadcaster.length }}</td>
                    <td>{{ Broadcaster.identifierType }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <delete-popup
      :deletePopup="deleteTemplateDefinitionPopup"
      :title="$t('setup.label.TemplateDefinition')"
      @deletePressed="deleteBroadcaster()"
      @cancelPressed="deleteTemplateDefinitionPopup = false"
    >
    </delete-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      id: "",
      viewBroadcaster: {},
      editJobsPopup: false,
      delId: 0,
      redirectToEdit: false,
      deleteTemplateDefinitionPopup: false,
      updateCraditPopup: false,
      jobsParameterPopup: false,
    };
  },
  components: {
    "v-select": vSelect,
  },
  computed: {
    ...mapState({
      broadcaster: (state) => state.usageRating.ViewTemplate,
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
  },
  methods: {
    getDate(date) {
      return moment(date).format(this.formattedDate);
    },
    editData(id) {
      this.$router.push({ name: "Edit Template", params: { id: id } });
    },
    async deleteBroadcaster() {
      this.deleteTemplateDefinitionPopup = false;
      await this.$store.dispatch(
        "usageRating/deleteTemplateDefinitionAction",
        this.id
      );
      this.$router.push(`/setup/usage-rating/template`);
    },

    async getBroadcasterById() {
      try {
        await this.$store.dispatch("usageRating/setViewTemplate", this.id);
        this.viewBroadcaster = this.broadcaster;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  mounted() {
    this.id = this.$route.params.id;
    this.getBroadcasterById();
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
</style>
